import { render } from "./icon-gr-check.svg?vue&type=template&id=b368ee76?inline"
const script = {}
script.render = render

export default script